<template>
    <b-modal hide-footer ref="FontLibrary" id="FontLibrary" scrollable size="xl">
        <div slot="modal-header" class="fontlibraryheader">
            <h2>Font library</h2>
            <b-button variant="primary" size="sm" @click="updateFontsOnServer" class="saveclosefonts">Save & close</b-button>
        </div>
        <div class="font-picker">
            

            
            <b-alert show>Please select carefully and only fonts you will be using throughout your apps on the site, while we do optimize and will only load font stylesheets once per site, using too many fonts can slow down your website speed.</b-alert>

            <div class="font-list">
                
                <font-picker-name v-for="(fontName, index) in filteredFonts" :key="index" :fontName="fontName"></font-picker-name>

            </div>
            
            <div class="modal-sidebar">

                <div class="modal-sidebar--inner">

                    <!-- search font family input -->
                    <h6 class="fw-title-bluebg">search font family</h6>
                    <b-form-group>
                        <b-form-input
                        id="searchFontInput"
                        type="text" 
                        v-model="searchFont"
                        placeholder="Search..."
                        />
                    </b-form-group>

                    <!-- filter font categories -->
                    <h6 class="fw-title-bluebg" style="margin-top:45px">categories</h6>
                    <b-form-group>
                        <b-form-checkbox 
                        v-model="fontSettings.serif"
                        >
                        Serif
                        </b-form-checkbox>
                        <b-form-checkbox 
                        v-model="fontSettings.sansserif"
                        >
                        Sans Serif
                        </b-form-checkbox>
                        <b-form-checkbox 
                        v-model="fontSettings.display"
                        >
                        Display
                        </b-form-checkbox>
                        <b-form-checkbox 
                        v-model="fontSettings.handwriting"
                        >
                        Handwriting
                        </b-form-checkbox>
                        <b-form-checkbox 
                        v-model="fontSettings.monospace"
                        >
                        Monospace
                        </b-form-checkbox>
                    </b-form-group>


                    <h6 class="fw-title-bluebg" style="margin-top:45px">font preview</h6>
                    <div>{{fontPreviewSettings.fontFamilyPreview}} @{{fontSize}}px</div>

                    <div class="font-preview-text">
                        <div class="font-preview-font-size-setter">
                            
                            <b-button variant="outline-secondary" size="sm" @click="changeFontSize(-2)" v-b-tooltip.hover title="Decrease size" :class="{'noSmaller': sizeTooSmall}">
                                -
                            </b-button>

                            <b-button variant="outline-secondary" size="sm" v-b-tooltip.hover title="Increase size" @click="changeFontSize(2)" :class="{'noTaller' : sizeTooTall}">
                                +
                            </b-button>
                            
                        </div>
                        <vstyle>
                            @import url('https://fonts.googleapis.com/css?family={{fontPreviewSettings.fontFamilyGoogle}}');
                        </vstyle>
                        <!-- <textarea v-model="previewTextAreaText" :style="{ fontSize: fontSize + 'px', fontFamily: fontPreviewSettings.fontFamilyPreview, fontWeight: fontPreviewSettings.fontWeightPreview, fontStyle: fontPreviewSettings.fontStylePreview }" class="fontpreviewbox" @change="checkIfEmpty">
                        
                            
                        </textarea> -->
                        <div class="preview-text-box" contenteditable="true" :style="{ fontSize: fontSize + 'px', fontFamily: fontPreviewSettings.fontFamilyPreview, fontWeight: fontPreviewSettings.fontWeightPreview, fontStyle: fontPreviewSettings.fontStylePreview }" @blur="checkIfEmpty">
                            {{previewTextAreaText}}
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </b-modal>
</template>


<script>
import Vue from 'vue'
import axios from 'axios'
import FontPickerName from './Fontpickername'

export default {

    name: 'Fontpicker',

    data() {

        return {
            
            // preview text area text
            previewTextAreaText: 'Click to type preview text...',

            // google fonts array
            entireGoogleLibraryArray: [],
            // search input field
            searchFont: '',

            showfont: false,

            fontSize: 17,
            sizeTooSmall: false,
            sizeTooTall: false,

            // get font family things
            // fontFamily: 'Arimo',
            // fontFam: 'Arimo'
            
        }
        

    },

    methods: {
        
        checkIfEmpty() {
            const textVal = event.target.textContent
            console.log(textVal)
            if( textVal.replace(/\s/g,'') == '' ) {
                event.target.textContent = 'Click here to modify preview text...'
            }
        },

        changeFontSize(sum){

            this.fontSize += sum

            this.fontSize === 10 ? this.sizeTooSmall = true : this.sizeTooSmall = false

            this.fontSize === 40 ? this.sizeTooTall = true : this.sizeTooTall = false
            
        },

        updateFontsOnServer() {
            let fd = new FormData();
            
            fd.append('fonts', this.$store.state.googleFontsToLoad)
            fd.append('jwt-token', this.$store.state.jwtToken)
            
            axios.post('https://www.appjustable.com/weebly/app_in_process/buttons/update_fonts.php',fd)
            .then((response)=> {
                console.log(response)
                this.$refs['FontLibrary'].hide()
            }).catch( (error)=> {
                console.log(error)
            })
        }

    },

    computed: {

        // filter font families
        filteredFonts() {
            if(this.searchFont.toLowerCase() === '?' || this.searchFont.toLowerCase() === '+') {
                console.log('this is bad character')
                return
            }
            return this.entireGoogleLibraryArray.filter(fontName => {
                return fontName.family.toLowerCase().match(this.searchFont.toLowerCase())
            })
        },

        // get stored settings
        fontSettings() {
            return this.$store.state.fontCategories
        },

        // font preview settings
        fontPreviewSettings() {
            return this.$store.state.fontPreview
        },

        // google font picker
        googleFontsArray() {
            this.fontArrayToCheck = this.$store.state.googleFontsToLoad
            return this.$store.state.googleFontsToLoad
        }

    },

    components: {

        'font-picker-name': FontPickerName,

        'vstyle': {
            render: function (createElement) {

                return createElement('style', this.$slots.default)
                
            }
        }

    },

    created() {

        axios.get('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyC7yvo-AJhO46p8mhUYdHBlOSur5cfABfc')
        .then(response => {

            const fontArrays = response.data.items
            
            fontArrays.forEach( fontFamily => {

                this.entireGoogleLibraryArray.push(fontFamily)

            })

        })
    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';

h6.fw-title-bluebg {
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.05em;
    color: @title_grey;
    line-height: 1;
    padding: 15px 0;
    text-align: center;
    font-weight: 700;
    position: relative;
    margin-bottom: 20px;
    background: @border_grey_medium;
    width: calc(100% + 30px);
    margin-left: -15px;
    margin-top: 15px;
}

#FontLibrary {
    .fontlibraryheader {
        position: relative;
        width: 100%;
        h2 {
            font-size: 24px;
        }
        .saveclosefonts {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 15px;
            font-weight: 700;
        }
    }
    .modal-dialog-scrollable {
        max-width: none!important;
        width: 100%!important;
        max-height: 100%;
        margin: 0 auto;
        min-height: 100%;
    }
    .modal-dialog-scrollable .modal-content {
        max-height: 100%;
        border: 0;
        border-radius: 0;
    }
    .modal-dialog-scrollable .modal-body {
        padding-left: 265px;
        background: @shark_teeth;
    }
    .modal-header {
        border-radius: 0;
        background: @white;
        z-index: 10;
        box-shadow: 0px 3px 10px rgba(0,0,0,.1);
    }
    .modal-sidebar {
        width: 250px;
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        background: #fff;
        border-right: 1px solid #dee2e6;
        padding-top: 63px;

        .modal-sidebar--inner {
            overflow-y: auto;
            height: 100%;
            padding: 30px 15px;

            .settings-divider {
                width: calc(~"100% + 30px");
                margin-left: -15px;
            }

            label:not(.custom-control-label), legend {
                font-size: 12px;
                font-weight: 700;
                color: #333D47;
            }
        }
    }
}

.font-picker {
    max-width: 1100px;
    margin: 0 auto;
}

.font-list {
    display: flex;
    flex-wrap: wrap;

    h6 {
        color: @text_grey;
        font-weight: normal;
        text-transform: capitalize;
        font-size: 17px;
        margin: 10px 0;
    }
}
.font-variant-list {
    display: none;
}
.font-variant-list.active {
    display: block;
}
.font-list-element {
    position: relative;
    display: flex;
    display: block;
    text-align: center;
    padding: 15px;
    border: 1px solid @border_grey_medium;
    background: @white;
    width: 31.33%;
    margin: 1%;
    border-radius: .25rem;
    transition: all .3s ease-out;

    &:hover {
        box-shadow: 0 7px 17px fade(@border_grey_medium, 70%);
    }

    &.active {
        border-color: @action_blue;
        border-bottom: 0;
        border-radius: .25rem .25rem 0 0;
        background: @light_blue;
    }
}

.font-picker-weight-list {
    position: absolute;
    background: #fff;
    width: calc(~"100% + 2px");
    left: -1px;
    top: 100%;
    border: 1px solid @action_blue;
    border-top: 1px solid @border_grey_dark;
    z-index: 10;
    text-align: left;
    padding: 0 15px;
    max-height: 285px;
    overflow-y: auto;
    border-radius: 0 0 .25rem .25rem;

    label {
        margin-left: 7px;
        cursor: pointer;

        &:hover {
            color: @text_grey;
        }
    }

    & > div {
        margin: 7px 0;
        border-bottom: 1px solid @border_grey_medium;
        padding: 15px 7px;
        color: @title_grey;
        position: relative;

        &:last-of-type {
            border-bottom: 0;
        }

        i {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            padding: 7px;
            cursor: pointer;

            &:hover {
                color: @action_blue;
            }
        }
    }
    
}
.font-list {
    .toggle-click {
        cursor: pointer;
        color: @title_grey;
        font-weight: 700;
        font-size: 12px;
        padding: 15px 0;

        &:hover {
            color: @action_blue;
        }
        i {
            margin-left: 7px;
            color: @action_blue;
        } 
    }
    .active .toggle-click {
        color: @action_blue;
    }
}

.font-preview-font-size-setter {
    text-align: left;
    margin: 10px 0;

    button {
        min-width: 31px;
        margin-right: 7px;
        font-size: 15px;
        background: none!important;
        border-color: @border_grey_dark;
        color: @text_grey!important;

        &:focus, &:active {
            outline: none!important;
            box-shadow: none!important;
        }
    }
}

.noSmaller, .noTaller {
    pointer-events: none;
    opacity: .3;
}

.preview-text-box {
    color: black;
    padding: 5px;

    &:focus {
        background: @shark_teeth;
        box-shadow: none;
        outline: none;
    }
}

@media(max-width: 980px){
    .font-list > div {
        width: 46%;
        margin: 2%;
    } 
}
@media(max-width: 767px){
    .font-list > div {
        width: 100%;
        margin: 10px 0;
    } 
}
</style>



// WEBPACK FOOTER //
// src/components/elements/elementSettings/Fontpicker.vue